import {
  Component,
  ElementRef,
  ViewChild,
  EventEmitter,
  OnInit,
  OnDestroy
} from "@angular/core";

/**
 * Exibe a camera do navegador, verifica o suporte e permissÃ£o para utilizaÃ§Ã£o da camera e tira fotos.
 *
 * Demo: {@link https://gituex.gitlab.io/extensions/web-extensions#components/camera}
 */
@Component({
  selector: "uex-camera",
  templateUrl: "./camera.component.html",
  host: {
    class: "uex-camera"
  }
})
export class CameraComponent implements OnInit, OnDestroy {
  @ViewChild("cameraWrapper", { static: true }) private _cameraWrapper: any;

  /**
   * @ignore
   */
  constructor(public elementRef: ElementRef) {}

  /**
   * Status atual da camera
   */
  public status: CameraStatus = {
    support: true,
    permission: true,
    error: false
  };

  /**
   * Ãltima foto registrada com a camera
   */
  public picture: string;

  /**
   * Evento emitido quando as camera for carregada, com sucesso ou falha
   */
  public onReady: EventEmitter<CameraStatus> = new EventEmitter();

  private _stream: MediaStream;
  private _navigator: any = navigator;
  private _destroyed: boolean;

  public ngOnInit() {
    this._getStream((stream: MediaStream, err: MediaStreamError) => {
      if (stream) {
        if (this._destroyed) {
          this._stop(stream);
        } else {
          this._play(stream);
        }
      } else if (err) {
        console.warn(err);
        this._onError(err);
      } else {
        this.status.support = false;
        this._onError();
      }
    });
  }

  public ngOnDestroy() {
    this._destroyed = true;
    this._stop();
  }

  /**
   * Retorna a distÃ¢ncia do elemento para o topo do elemento pai mais prÃ³ximo posicionado com relative
   */
  public get offsetTop(): number {
    return this.elementRef.nativeElement.offsetTop;
  }

  /**
   * Tira a foto e returna um base64 da imagem
   */
  public takePicture(): string {
    if (!this._cameraWrapper && !this.status.error) {
      return null;
    }
    const canvas = this._getCanvas(this._cameraWrapper.nativeElement);
    this.picture = canvas.toDataURL("image/jpeg");
    return this.picture;
  }

  private _getCanvas(wrapper: HTMLVideoElement): HTMLCanvasElement {
    const canvas = document.createElement("canvas");
    canvas.width = this._cameraWrapper.nativeElement.videoWidth;
    canvas.height = this._cameraWrapper.nativeElement.videoHeight;
    canvas.getContext("2d").drawImage(wrapper, 0, 0);
    return canvas;
  }

  private _play(stream: MediaStream) {
    if (this._cameraWrapper) {
      this._stream = stream;
      // this._cameraWrapper.nativeElement.src = window.URL.createObjectURL(stream);
      this._cameraWrapper.nativeElement.srcObject = stream;
      this._cameraWrapper.nativeElement.play();
      this._onSuccess();
    }
  }

  private _stop(stream: MediaStream = this._stream) {
    if (stream) {
      const tracks: Array<MediaStreamTrack> = stream.getTracks();
      if (tracks) {
        tracks.forEach(track => track.stop());
      }
    }
    if (this._cameraWrapper) {
      this._cameraWrapper.nativeElement.pause();
    }
  }

  private _onSuccess() {
    this.onReady.emit(this.status);
  }

  private _onError(err?: any) {
    if (
      err &&
      (err.name == "PermissionDeniedError" || err.name == "NotAllowedError")
    ) {
      this.status.permission = false;
    }
    this.status.error = true;
    this.onReady.emit(this.status);
  }

  private _getStream(
    callback: (stream: MediaStream, err: MediaStreamError) => void
  ) {
    // Primary
    if (
      this._navigator.mediaDevices &&
      this._navigator.mediaDevices.getUserMedia
    ) {
      // Not adding `{ audio: true }` since we only want video now
      this._navigator.mediaDevices
        .getUserMedia({ video: true })
        .then((stream: MediaStream) => callback(stream, null))
        .catch((err: MediaStreamError) => callback(null, err));

      // Standard
    } else if (this._navigator.getUserMedia) {
      this._navigator.getUserMedia(
        { video: true },
        (stream: MediaStream) => callback(stream, null),
        (err: MediaStreamError) => callback(null, err)
      );

      // WebKit-prefixed
    } else if (this._navigator.webkitGetUserMedia) {
      this._navigator.webkitGetUserMedia(
        { video: true },
        (stream: MediaStream) => callback(stream, null),
        (err: MediaStreamError) => callback(null, err)
      );

      // Mozilla-prefixed
    } else if (this._navigator.mozGetUserMedia) {
      this._navigator.mozGetUserMedia(
        { video: true },
        (stream: MediaStream) => callback(stream, null),
        (err: MediaStreamError) => callback(null, err)
      );

      // Missing Support
    } else {
      callback(null, null);
    }
  }
}

export interface CameraStatus {
  support: boolean;
  permission: boolean;
  error: boolean;
}
